// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCWUv5wNb0eRN6aA0lG_37NtufuzrfumwA",
  authDomain: "alaia-cristal.firebaseapp.com",
  projectId: "alaia-cristal",
  storageBucket: "alaia-cristal.firebasestorage.app",
  messagingSenderId: "972704239206",
  appId: "1:972704239206:web:6001d6a0872ac71715a7a7",
  measurementId: "G-N7D003QL2X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

const analytics = getAnalytics(app);